export default __webpack_public_path__ + "static/media/curvedBg.02cda4fa.jpg";